import { Center, chakra, Heading } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Center bg="#f9bf3b" h="80px" color="#000">
      <Heading size="md" px={5} isTruncated>
        Made with
        <chakra.span color="#ff0000" display="inline">
          {' '}
          &hearts;
        </chakra.span>{' '}
        in Riihim&auml;ki, Finland
      </Heading>
    </Center>
  );
};

export default Footer;
